(function () {
'use strict';
var D = window.Delume || {};
var $ = function (s, c) { return (c || document).querySelector(s); };
var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
var formatMoney = function (c) { return D.formatMoney ? D.formatMoney(c) : c; };
function initProduct(root) {
var picker = $('[data-variant-picker]', root);
var form = $('[data-product-form="main"]', root);
var idInput = form && $('[data-variant-id]', form);
var addBtn = form && $('[data-add-button]', form);
var priceEl = $('[data-price]', root);
var compareEl = $('[data-compare]', root);
var priceWrap = $('[data-price-wrap]', root);
var sticky = document.querySelector('[data-sticky-buy]');
var track = $('[data-gallery-track]', root);
var counter = $('[data-gallery-index]', root);
var variants = [];
if (picker) { try { variants = JSON.parse($('[data-variants]', picker).textContent); } catch (e) {} }
function setButton(v) {
if (!addBtn) return;
var label = !v ? 'Unavailable' : (v.available ? 'Add to bag' : 'Sold out');
addBtn.textContent = label;
addBtn.disabled = !v || !v.available;
if (addBtn.disabled) addBtn.setAttribute('data-sold-out', ''); else addBtn.removeAttribute('data-sold-out');
if (sticky) { var sb = $('[data-sticky-add]', sticky); sb.textContent = label; sb.disabled = addBtn.disabled; }
}
function markUnavailable() {
if (!picker) return;
var chosen = $$('fieldset', picker).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
$$('.opt__input', picker).forEach(function (inp) {
var idx = parseInt(inp.dataset.optionIndex, 10);
var test = chosen.slice(); test[idx] = inp.value;
var match = variants.some(function (v) { return v.available && v.options.every(function (o, i) { return i === idx || o === test[i] || test[i] === null; }) && v.options[idx] === inp.value; });
inp.nextElementSibling.classList.toggle('is-unavailable', !match);
});
}
function onChange() {
var chosen = $$('fieldset', picker).map(function (fs, i) {
var c = $('input:checked', fs);
var lbl = $('[data-option-label="' + i + '"]', picker);
if (lbl && c) lbl.textContent = c.value;
return c ? c.value : null;
});
var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); });
setButton(v);
markUnavailable();
if (!v) return;
if (idInput) idInput.value = v.id;
if (priceEl) priceEl.textContent = formatMoney(v.price);
var sale = v.compare_at_price && v.compare_at_price > v.price;
if (compareEl) { compareEl.hidden = !sale; compareEl.textContent = sale ? formatMoney(v.compare_at_price) : ''; }
if (priceWrap) priceWrap.classList.toggle('price--sale', !!sale);
if (sticky) $('[data-sticky-price]', sticky).textContent = formatMoney(v.price);
if (v.featured_media && track) {
var slide = $('[data-media-id="' + v.featured_media.id + '"]', track);
if (slide) {
if (track.scrollWidth > track.clientWidth + 4) track.scrollTo({ left: slide.offsetLeft - track.firstElementChild.offsetLeft, behavior: 'smooth' });
else if (slide !== track.firstElementChild) track.insertBefore(slide, track.firstElementChild);
}
}
if (!root.hasAttribute('data-no-url')) {
var url = new URL(window.location.href);
url.searchParams.set('variant', v.id);
window.history.replaceState({}, '', url.toString());
}
}
if (picker) { picker.addEventListener('change', onChange); markUnavailable(); }
var thumbs = $$('[data-thumb]', root);
if (track && (counter || thumbs.length)) {
track.addEventListener('scroll', function () {
var i = Math.round(track.scrollLeft / track.clientWidth);
if (counter) counter.textContent = i + 1;
thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
}, { passive: true });
}
thumbs.forEach(function (t) {
t.addEventListener('click', function () {
var slide = $('[data-media-id="' + t.dataset.thumb + '"]', track);
if (slide) track.scrollTo({ left: slide.offsetLeft - track.firstElementChild.offsetLeft, behavior: 'smooth' });
});
});
if (sticky && addBtn && 'IntersectionObserver' in window) {
sticky.hidden = false;
new IntersectionObserver(function (entries) {
var e = entries[0];
sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
}).observe(addBtn);
$('[data-sticky-add]', sticky).addEventListener('click', function () {
if (form.requestSubmit) form.requestSubmit(); else D.addToCart(form);
});
}
}
function initTabs(root) {
var tabs = $$('[data-tab]', root);
tabs.forEach(function (tab, i) {
tab.addEventListener('click', function () { select(i); });
tab.addEventListener('keydown', function (e) {
if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
e.preventDefault();
var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
select(n); tabs[n].focus();
}
});
});
function select(n) {
tabs.forEach(function (t, i) {
var on = i === n;
t.setAttribute('aria-selected', on ? 'true' : 'false');
t.tabIndex = on ? 0 : -1;
var p = document.getElementById(t.getAttribute('aria-controls'));
if (p) p.hidden = !on;
});
}
if (tabs.length) select(0);
}
document.addEventListener('click', function (e) {
var b = e.target.closest('[data-scroll]');
if (!b) return;
var track = $('[data-scroller-track]', b.closest('[data-scroller]'));
if (track) track.scrollBy({ left: parseInt(b.dataset.scroll, 10) * track.clientWidth * 0.8, behavior: 'smooth' });
});
function initSlideshow(root) {
var track = $('[data-slides]', root);
var dots = $$('[data-dot]', root);
if (!track || dots.length < 2) return;
var idx = 0, timer = null;
var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function go(n) { idx = (n + dots.length) % dots.length; track.scrollTo({ left: idx * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); }
function mark() { dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); d.setAttribute('aria-current', i === idx ? 'true' : 'false'); }); }
dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); restart(); }); });
track.addEventListener('scroll', function () { idx = Math.round(track.scrollLeft / track.clientWidth); mark(); }, { passive: true });
function restart() {
clearInterval(timer);
if (root.dataset.autoplay === 'true' && !reduce) timer = setInterval(function () { go(idx + 1); }, parseInt(root.dataset.interval, 10) || 6000);
}
root.addEventListener('mouseenter', function () { clearInterval(timer); });
root.addEventListener('mouseleave', restart);
root.addEventListener('focusin', function () { clearInterval(timer); });
restart();
}
function initAnnounce(root) {
var msgs = $$('.announce__msg', root);
if (msgs.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
var i = 0;
setInterval(function () {
msgs[i].classList.remove('is-active');
i = (i + 1) % msgs.length;
msgs[i].classList.add('is-active');
}, parseInt(root.dataset.interval, 10) || 5000);
}
function initCountdown(el) {
var raw = el.dataset.countdown.trim().replace(' ', 'T');
if (raw.length === 16) raw += ':00';
var end = new Date(raw);
if (isNaN(end)) return;
var units = { d: $('[data-unit="d"]', el), h: $('[data-unit="h"]', el), m: $('[data-unit="m"]', el), s: $('[data-unit="s"]', el) };
function pad(n) { return (n < 10 ? '0' : '') + n; }
function tick() {
var diff = Math.max(0, end - new Date());
if (diff === 0) {
el.classList.add('is-ended');
$('.countdown__label', el).textContent = el.dataset.ended;
clearInterval(t); return;
}
var s = Math.floor(diff / 1000);
units.d.textContent = pad(Math.floor(s / 86400));
units.h.textContent = pad(Math.floor(s % 86400 / 3600));
units.m.textContent = pad(Math.floor(s % 3600 / 60));
units.s.textContent = pad(s % 60);
}
var t = setInterval(tick, 1000); tick();
}
function initRecs(el) {
if (el.querySelector('.card') || !el.dataset.url) return;
fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
var doc = new DOMParser().parseFromString(html, 'text/html');
var fresh = $('[data-recs]', doc);
if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
}).catch(function () {});
}
function initAddressSelects() {
$$('select[data-default]').forEach(function (s) { if (s.dataset.default) s.value = s.dataset.default; });
}
function init(scope) {
scope = scope || document;
$$('[data-product]', scope).forEach(initProduct);
$$('[data-tabs]', scope).forEach(initTabs);
$$('[data-slideshow]', scope).forEach(initSlideshow);
$$('[data-announce]', scope).forEach(initAnnounce);
$$('[data-countdown]', scope).forEach(initCountdown);
$$('[data-recs]', scope).forEach(initRecs);
initAddressSelects();
}
document.addEventListener('DOMContentLoaded', function () { init(document); });
document.addEventListener('shopify:section:load', function (e) { init(e.target); });
document.addEventListener('shopify:block:select', function (e) {
var tab = e.target.closest('[data-tab]');
if (tab) tab.click();
var slide = e.target.closest('.hero__slide');
if (slide) { var t = slide.parentNode; t.scrollTo({ left: slide.offsetLeft }); }
});
})();